// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1w-6";
export var headerCell = "_1w-2";
export var rowWrapper = "_1w-4";
export var stickyAggregationCell = "_1w-a";
export var stickyAggregationRow = "_1w-7";
export var stickyColumnCell = "_1w-9";
export var stickyColumnHeaderCell = "_1w-8";
export var table = "_1w-1";
export var virtualRowWrapper = "_1w-5";
export var virtualTableContainer = "_1w-0";
export var white = "_1w-3";